import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './shared/styles/globals.css';
import App from './app';
// import { preloadRecaptcha } from '@/shared/lib/recaptcha';

// preloadRecaptcha();
//
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);


